/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import {Injectable} from '@angular/core';

import {DataQuery} from '@typescript-kit/data';
import {HttpService} from '@angular-kit/core';

import {Location, LocationData} from '@teamworks/global';

@Injectable()
export class LocationService {

  constructor(private httpService: HttpService) {
  }

  async loadLocationList(dataQuery?: DataQuery): Promise<Location[]> {
    return this.httpService.get(`/api/base-data/location-list`, {'data-query': dataQuery})
      .then((loadedData: LocationData[]) => loadedData.map(data => new Location(data)));
  }

  async saveLocation(data: LocationData): Promise<Location> {
    return this.httpService.post(`/api/base-data/location`, data)
      .then((savedData: LocationData) => new Location(savedData));
  }

  async deleteLocation(id: string): Promise<Location> {
    return this.httpService.delete(`/api/base-data/location/${encodeURIComponent(id)}`)
      .then((deletedData: LocationData) => new Location(deletedData));
  }
}
